import React, { useEffect } from 'react'
import 'antd/dist/reset.css'
// import 'antd/dist/antd.less'
import './App.less'
import 'nprogress/nprogress.css'
import config from './config'

import LoadingOverLay from './components/LoadingOverLay'
// region Router
import { Route, Routes } from 'react-router-loading'
import history from './customRouter/history'
import CustomRouter from './customRouter/CustomRouter'
import { PAGES } from './constant'
import AuthLayout from './layout/AuthLayout'
import ProtectedLayout from './layout/ProtectedLayout'
import HomePage from './pages/HomePage'
import NotFoundPage from './pages/NotFoundPage'
import ThemeProvider from './theme/ThemeProvider'
import PublicLayout from './layout/PublicLayout'
import RegisterPage from './pages/RegisterPage'
import BlankLayout from './layout/BlankLayout'
import HomePreviewPage from './pages/HomePreviewPage'
import landingPageStore from './stores/landingPageStore'
import RegisterPreviewPage from './pages/RegisterPreviewPage'
import RegisterSuccess from './pages/RegisterSuccess'

// endregion

function App() {
  useEffect(() => {
    landingPageStore.getPageConfig()
      .then(res => {
        landingPageStore.getPageStatus()
      })
  }, [])

  return (
    <CustomRouter history={history} basename={config.basePath}>
      <ThemeProvider>

        <Routes>
          <Route element={<AuthLayout />}>

          </Route>
          <Route element={<ProtectedLayout />}>

          </Route>
          <Route element={<PublicLayout />}>
            <Route path={`${PAGES.REGISTER_PREVIEW_SME.PATH}/:id?`} element={<RegisterPreviewPage />} />

            <Route path={`${PAGES.REGISTER_SME.PATH}/:id?`} element={<RegisterPage />} />
            <Route path={`${PAGES.REGISTER_SUCCESS.PATH}`} element={<RegisterSuccess />} />

            <Route path={`${PAGES.HOME.PATH}/:id?`} element={<HomePage />} />
            <Route path={`${PAGES.PREVIEW.PATH}/:id?/:data?`} element={<HomePreviewPage />} />
          </Route>
          <Route element={<BlankLayout />}>

          </Route>
          <Route path="*" element={<NotFoundPage />} />
        </Routes>

        <LoadingOverLay />
      </ThemeProvider>
    </CustomRouter>
  )
}

export default App
